if(!global["simple"]) global["simple"] = {};
module.exports = global["simple"]["uploader"] = require("-!/www/tower/releases/20210628040636/node_modules/babel-loader/lib/index.js??ref--11-0!./uploader.js");